import { IconButton, Stack, Tooltip } from "@mui/material";
import EditIcon from "src/assets/svg-icons/aggregators/edit.svg";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DeleteIcon from "src/assets/svg-icons/aggregators/delete.svg";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { notificationsState } from "src/store/notifications";
import { useNavigate } from "react-router-dom";
import {
  useDeleteStockCountMutation,
  useDownloadStockCountDetails,
} from "src/api/inventory/counts";
import { ConfirmPopup } from "src/shared/components/confirm-popup";
import DownloadIcon from "src/assets/svg-icons/download.svg";
import { downloadAsXLS, specificBranchHasPermission } from "src/utils";
import { InventoryPermissions } from "src/constants/permissions";
import { useDownloadAdjustmentDetails } from "src/api/inventory/adjustments";

const TableActions = ({ row, refetch }: { row: any; refetch: Function }) => {
  const navigate = useNavigate();
  const { t: generalT } = useTranslation("general");
  const [notifications, setNotifications] = useRecoilState(notificationsState);

  // APIS
  const {
    data: downloadedData,
    refetch: refetchDownload,
    isFetching: isFetchingDownload,
    status: downloadStatus,
  } = useDownloadAdjustmentDetails({
    adjustmentId: row.id,
  });

  const handleDownload = () => {
    refetchDownload();
  };

  const navigateToViewAdjustments = (id: any) => {
    navigate(`/adjustments/${id}/view`);
  };

  useEffect(() => {
    if (
      downloadStatus === "success" &&
      !!downloadedData &&
      !isFetchingDownload
    ) {
      const utf8CSVData = `\uFEFF${downloadedData}`;
      downloadAsXLS(utf8CSVData, `stocktaking-${row.reference}`);
    }
  }, [isFetchingDownload]);

  return (
    <Stack
      direction={"row"}
      spacing={"12px"}
      width={"100%"}
      justifyContent={"center"}
    >
      <Tooltip title={generalT("details")}>
        <IconButton onClick={() => navigateToViewAdjustments(row.id)}>
          <VisibilityOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip title={generalT("download")}>
        <IconButton onClick={handleDownload} disabled={isFetchingDownload}>
          <img src={DownloadIcon} alt="" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
export default TableActions;
